import { Loading, Modal } from "@componentes-mu/componentes-mu";


export const LoadingOverlay = () => (
    <Modal
        isOpen
        onClose={() => { }}
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            boxShadow: "none",
        }}
    >
        <div
            style={{
                position: "relative",
                width: "100px",
                height: "100px",
            }}
        >
            <Loading carregandoConteudo />
        </div>
    </Modal>
)